import {
  phoneObfuscateRegex,
  phoneObfuscateMaskPattern
} from '@/constants';

export default (phone) => {
  if(phone) {
    return phone.replace(phoneObfuscateRegex, phoneObfuscateMaskPattern);
  }
  return phone;
};